import axios from './http'
import de from "element-ui/src/locale/lang/de";

/**
 * 报名
 * @type {{changeCertificateStatus(*=, *=): Promise<AxiosResponse<any>>, enterForData(*=): Promise<AxiosResponse<*>>, getCertificateInfoByUserId(*): Promise<AxiosResponse<any>>, getAllCertificateInfosOfBrief(*): Promise<AxiosResponse<any>>, getEnterForData(): Promise<AxiosResponse<any>>}}
 */
const enterFor = {

  /**
   * 报名
   * @param certificateInfo
   * @returns {Promise<AxiosResponse<any>>}
   */
  enterForData(certificateInfo) {
    return axios.post('/thesis/certificate', certificateInfo)
  },

  /**
   * 得到报名信息
   */
  getEnterForData() {
    return axios.get('/thesis/certificate')
  },

  /**
   * 管理员获取所有认证信息的摘要-不包含小组成员信息
   * @param useType 1:所有状态的；2:正在审核的；3:审核通过的；4:审核失败的；
   * @param teamGrade 学历筛选条件
   * @return
   */
  getAllCertificateInfosOfBrief(teamGrade) {
    let str = teamGrade ? `&teamGrade=${teamGrade}` : ''
    return axios.get(`/thesis/certificate/getAllCertificateInfosOfBrief?useType=1` + str)
  },

  /**
   * 管理员通过用户id查询详细信息
   * @param userId 用户id
   */
  getCertificateInfoByUserId(userId) {
    return axios.get('/thesis/certificate/' + userId)
  },

  /**
   * 管理员更改某个用户报名认证状态
   * @param userId
   * @param certificateStatus 更改的审核状态
   */
  changeCertificateStatus(userId, certificateStatus,certificateReason) {
    let param = new URLSearchParams()
    param.append('userId', userId)
    param.append('certificateStatus', certificateStatus)
    param.append('certificateReason', certificateReason)
    return axios.post('/thesis/certificate/changeCertificateStatus', param)
  },

  /**
   * 管理员修改用户详细信息
   * @param userId 用户id
   */
  updateCertificateInfoByUserId(certificateInfo) {
    return axios.post('/thesis/certificate/changeCertificateInfo', certificateInfo)
  },

  /**
   *
   * @returns {Promise<AxiosResponse<T>>}
   */
  sendBatchSmsBefore(){
    return axios.get('/thesis/certificate/sendBatchSmsBefore')
  },

  /**
   *
   * @returns {Promise<AxiosResponse<T>>}
   */
  sendBatchSms(){
    return axios.post('/thesis/certificate/sendBatchSms')
  },

  /**
   * 获取用户认证信息+论文摘要+终审信息
   * @returns 
   */
  getThesisAbstractVOByUserId() {
    return axios.get('/thesis/work/getThesisAbstractVOByUserId')
  },

  /**
   * 报名并提交摘要信息
   */
  sendCertificateInfo(certificateInfo,thesisInfo){
    let param = new FormData()//通过form数据格式来传
    param.append("route", thesisInfo.file); //传文件
    param.append('chName', thesisInfo.chName)
    param.append('enName', thesisInfo.enName)
    param.append('chKeyWords', thesisInfo.chKeyWords)
    param.append('enKeyWords', thesisInfo.enKeyWords)
    param.append('certificateInfo',JSON.stringify(certificateInfo))
    return axios.post('/thesis/work/addNew', param)
  }

  

}

export default enterFor



// WEBPACK FOOTER //
// ./src/api/enterFor.js